import React from 'react';
import {FastField} from "formik";
import {Grid} from "@material-ui/core";

import CompanyAutoCompleteInputContainer from 'data/redux/containers/companyAutoCompleteInputContainer';
import FormikTextField from 'gui/components/formikTextField';

const FieldTypeShops = () => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <FastField
          component={CompanyAutoCompleteInputContainer}
          label="שם שובר לדוגמא גיפט כארד לחנויות אופנה *"
          name="voucherName"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormikTextField
          label="קישור לבתי עסק מכבדים (יש להעתיק מאתר מפיק השובר)"
          name={"websiteUrl"}
          placeholder={"https://www.example.com"}
        />
      </Grid>
    </>
  );
};

export default React.memo(FieldTypeShops);
